import React from "react";
import "./experience.css";
import leftAbout from "../../images/aboutUs/aboutLeft.png";
import rightAbout from "../../images/aboutUs/aboutRight.png";
import glades1 from "../../images/aboutUs/glades1.png";
import glades2 from "../../images/aboutUs/glades2.png";
import glades3 from "../../images/aboutUs/glades3.png";
import { NavLink } from "react-router-dom";
import ActivityHighlights from "./activityHighlights";
import AreaExplorer from "./areaExplorer";
import Customer from "../customer/customer";

const Experience = () => {
  return (
    <>
      <div className="relative w-full min-h-screen">
        {/* Background Image - Full Width */}
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bgExperienceBanner z-0"></div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        {/* Content Wrapper */}
        <div className="relative z-10 flex flex-col items-center justify-center h-screen text-center text-white px-4">
          <div className="flex flex-col gap-4">
            <div className="flex gap-3 justify-center">
              <div className="text-base poppins-medium">HOME</div>
              <div className="text-base poppins-medium">/</div>
              <div className="text-base poppins-medium">EXPERIENCES</div>
            </div>
            <h2 className="text-3xl md:text-6xl font-normal">
              OUR <span className="text-[#D1A752] underline">EXPERIENCES</span>
            </h2>
          </div>
        </div>
      </div>

      {/* Decorative images below banner */}
      <div
        className="flex md:gap-16 gap-4 justify-center relative z-20"
        style={{ marginTop: "-100px" }}
      >
        <div>
          <img
            src={leftAbout}
            alt="leftDecor"
            className="relative z-30 max-md:w-[180px]"
          />
        </div>
        <div>
          <img
            src={rightAbout}
            alt="rightDecor"
            className="relative z-30 max-md:w-[180px]"
          />
        </div>
      </div>

      {/* Introduction section */}
      <div className="mt-16 ml-8 max-md:px-4">
        <div
          className="md:flex gap-4"
          style={{ maxWidth: "1440px", margin: "auto" }}
        >
          <div className="md:w-[50%] flex flex-col gap-4">
            <div className="text-xl text-[#585858] poppins-medium">
              EXPERIENCE GIR GLADES
            </div>
            <div className="text-[42px] text-[#672220] font-bold">
              Unique Experiences Tailored to Your Preferences
            </div>
            <div className="text-xl text-[#5A5A5A] max-[742px] poppins-medium">
              At Gir Glades, your experience extends beyond luxurious accommodations. Our location offers you the perfect opportunity to connect with nature and explore the local culture. From spotting wildlife to visiting spiritual sanctuaries, every moment you spend at Gir Glades becomes a cherished memory.
            </div>

            <div className="text-xl text-[#5A5A5A] mt-2 max-[742px] poppins-medium">
              Every experience at Gir Glades is crafted to give you an authentic taste of Gir's rich ecosystem while ensuring your comfort and satisfaction.
            </div>
          </div>
          <div className="md:w-[50%] flex flex-col gap-4 mt-6 md:mt-0">
            <div className="quote-bg p-8 rounded-lg">
              <p className="text-2xl text-[#672220] italic font-light">
                "In every walk with nature, one receives far more than seeks."
              </p>
              <p className="text-right text-[#585858] mt-4">- John Muir</p>
            </div>
            <div className="flex flex-col gap-6 mt-6">
              {/* Feature 1 */}
              <div className="flex items-start gap-4">
                <img
                  src={glades1}
                  alt="Professional & Certified"
                  className="w-10 h-10"
                />
                <div>
                  <h3 className="text-[#212121] text-[22px] poppins-medium">
                    Cultural Experiences
                  </h3>
                  <p className="text-[#585858] text-[14px] poppins-regular">
                    Discover local customs and traditions through artistic performances 
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex items-start gap-4">
                <img
                  src={glades2}
                  alt="Get Best Villas Discount"
                  className="w-10 h-10"
                />
                <div>
                  <h3 className="text-[#212121] text-[22px] poppins-medium">
                    Natural Wonders
                  </h3>
                  <p className="text-[#585858] text-[14px] poppins-regular">
                    Explore lush green forests and revel in unfiltered nature’s beauty
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="flex items-start gap-4">
                <img
                  src={glades3}
                  alt="Luxurious & Comfortable Stays"
                  className="w-10 h-10"
                />
                <div>
                  <h3 className="text-[#212121] text-[22px] poppins-medium">
                    Wildlife Encounters
                  </h3>
                  <p className="text-[#585858] text-[14px] poppins-regular">
                    Interact with the diverse wildlife that calls Gir Forest their home
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Activity Highlights section */}
      <ActivityHighlights />

      {/* Area Explorer section */}
      <AreaExplorer />

      {/* Call to action */}
      <div className="my-16 mx-auto text-center max-w-[1440px] px-6">
        <h2 className="text-[42px] text-[#672220] font-bold mb-6">
          Ready to Book Your Adventure?
        </h2>
        <p className="text-xl text-[#5A5A5A] max-w-[800px] mx-auto mb-8">
          Book your stay at Gir Glades and embark on a journey of discovery, relaxation, and unforgettable adventures.
        </p>
        <NavLink
          to="/booking"
          className="inline-block text-[#672220] mt-6 border poppins-regular text-[14px] md:text-xl border-[#672220] h-[50px] px-8 justify-center items-center rounded-full hover:bg-[#672220] hover:text-white font-semibold transition flex"
        >
          + Book Your Experience
        </NavLink>
      </div>
    </>
  );
};

export default Experience;